import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useAuthStore } from '@features/auth/store/authStore';
import { logoutAsync } from '@features/auth/services/loginSvc';
import { SESSION_STORAGE_KEYS } from '@features/auth/constants/sessionStorageKeys';
import { clearClientSessionArtifacts } from '@features/auth/utils/clearClientSessionArtifacts';

export const useLogout = () => {
  const navigate = useNavigate();

  return useCallback(async () => {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.EXPLICIT_LOGOUT, '1');
    try {
      // Invalidate the server-side session; logoutAsync clears local state in its finally block.
      await logoutAsync();
    } catch {
      // Network/API failure — fall back to clearing local state so the user is never stuck.
      useAuthStore.getState().clearAccessToken();
      clearClientSessionArtifacts({ clearReturnUrl: true });
    }
    navigate('/login', { replace: true });
  }, [navigate]);
};
